/* import __COLOCATED_TEMPLATE__ from './reference-attribute-option.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();